var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader"}},[_c('div',{staticClass:"loaderspinwrap",attrs:{"id":_vm.id ? _vm.id : 'loaderspinwrap'}},[_c('div',{staticClass:"loaderspin",class:{ withtext: _vm.text, '': !_vm.text }}),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }